module.exports = __webpack_public_path__ + "images/sort-up-down-909e0368.png";